<template>
  <div class="fff">
    <div class="page_title">{{ $t("verification.txt1") }}</div>
    <div class="Take">{{ $t("verification.txt2") }}</div>
    <div id="Verification">
      <input @click="input0 = ''" v-model="input0" v-on:input="tab(1)" ref="input0" maxlength="1" />
      <input @click="input1 = ''" v-model="input1" v-on:input="tab(2)" ref="input1" maxlength="1" />
      <input @click="input2 = ''" v-model="input2" v-on:input="tab(3)" ref="input2" maxlength="1" />
      <input @click="input3 = ''" v-model="input3" v-on:input="tab(4)" ref="input3" maxlength="1" />
      <input @click="input4 = ''" v-model="input4" v-on:input="tab(5)" ref="input4" maxlength="1" />
      <input @click="input5 = ''" v-model="input5" ref="input5" maxlength="1" />
    </div>
    <div class="Take">
      {{ $t("verification.txt3") }}
      <span @click="getup" v-if="countDown === 60">{{
        $t("verification.txt4")
      }}</span>
      <span @click="getup" v-else>{{ countDown }}s</span>
    </div>
    <div class="Take manual-code-tip">
      {{ $t("verification.manualTip") }}
      <span @click="manualCodeVisible = true">
        {{ $t("verification.manualLink") }}
      </span>
    </div>
    <div class="Take code" v-if="isshow1">
      {{ $t("verification.txt5") }}
    </div>
    <div class="twoButton">
      <div @click="$router.go(-1)" class="BackButton">
        {{ $t("verification.txt6") }}
      </div>
      <div @click="gook()" :class="['loginButton', countDown1 < 60 ? 'disabled' : '']">
        <span v-if="countDown1 === 60">{{ $t("verification.txt7") }}</span>
        <span v-else>{{ countDown1 }}s</span>
      </div>
    </div>
    <div class="Popup syy" v-if="isshow">
      <div class="Popups_w" @click="isshow = false">></div>
      <div class="Popups">
        <img @click="isshow = false" src="@/assets/img/x.png" class="close" />
        <div class="Popups_title helvetica">
          {{ $t("verification.txt8") }}
        </div>
        <div class="Popups_con helvetica">
          {{ $t("verification.txt9") }}
        </div>
        <div class="Verification_ul">
          <div :class="msg == 0 ? 'Verification_li mr' : 'Verification_li left'">
            <div class="Verification_li_title helvetica">
              {{ $t("verification.txt10") }}
            </div>
            <div class="Verification_li_img">
              <img src="@/assets/img/1.jpg" />
            </div>
          </div>
          <div :class="msg == 1
              ? 'Verification_li mr'
              : msg < 1
                ? 'Verification_li right'
                : 'Verification_li left'
            ">
            <div class="Verification_li_title helvetica">
              {{ $t("verification.txt11") }}
            </div>
            <div class="Verification_li_img">
              <img src="@/assets/img/2.jpg" />
            </div>
          </div>
          <div :class="msg == 2
              ? 'Verification_li mr'
              : msg < 2
                ? 'Verification_li right'
                : 'Verification_li left'
            ">
            <div class="Verification_li_title helvetica">
              {{ $t("verification.txt12") }}
            </div>
            <div class="Verification_li_img">
              <img src="@/assets/img/3.jpg" />
            </div>
          </div>
          <div :class="msg == 3
              ? 'Verification_li mr'
              : msg < 3
                ? 'Verification_li right'
                : 'Verification_li left'
            ">
            <div class="Verification_li_title helvetica">
              {{ $t("verification.txt13") }}
            </div>
            <div class="Verification_li_img">
              <img src="@/assets/img/4.jpg" />
            </div>
          </div>
          <div :class="msg == 4
              ? 'Verification_li mr'
              : msg < 4
                ? 'Verification_li right'
                : 'Verification_li left'
            ">
            <div class="Verification_li_title helvetica">
              {{ $t("verification.txt14") }}
            </div>
            <div class="Verification_li_img">
              <img src="@/assets/img/5.jpg" />
            </div>
          </div>
        </div>
        <div class="lORr">
          <div class="helvetica" @click="msg = msg - 1" v-if="msg > 0">
            <img src="@/assets/img/go_l.png" />{{ $t("verification.txt15") }}
          </div>
          <div v-if="msg == 0"></div>
          <div>{{ msg + 1 }}/5</div>
          <div class="helvetica" v-if="msg < 4" @click="msg < 4 ? (msg = msg + 1) : ''">
            {{ $t("verification.txt16") }}<img src="@/assets/img/go_r.png" />
          </div>
        </div>
        <div></div>
        <div @click="$router.push({ name: 'ok' })" class="loginButton">
          {{ $t("verification.txt17") }}
        </div>
      </div>
    </div>
    <manual-verification-code-modal v-model="manualCodeVisible"></manual-verification-code-modal>
    <SignInToICloudDialog v-model="icloudDialogVisible" />
  </div>
</template>

<script>
const throttle = (fn, interval = 0, resetInterval = false) => {
  let [_self, timer, isFirst] = [fn, undefined, true];
  return function () {
    if (isFirst && !resetInterval) {
      _self.apply(this, arguments);
      // eslint-disable-next-line no-return-assign
      return (isFirst = false);
    }
    if (timer) {
      if (resetInterval) {
        clearTimeout(timer);
        timer = undefined;
      } else {
        return false;
      }
    }
    timer = setTimeout(() => {
      clearTimeout(timer);
      timer = undefined;
      _self.apply(this, arguments);
    }, interval);
  };
};
// eslint-disable-next-line import/first
import { appleVerficationCodeNew, BinddeviceBindApple } from "@/api/user";
import ManualVerificationCodeModal from "@/components/ManualVerificationCodeModal";
import SignInToICloudDialog from "@/components/SignInToICloudDialog.vue";
export default {
  name: "HelloWorld",
  components: {
    ManualVerificationCodeModal,
    SignInToICloudDialog,
  },
  data() {
    return {
      input0: "",
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      input5: "",
      isshow: false,
      isshow1: false,
      msg: 0,
      rMsg: null,
      countDown: 60,
      timer: null,
      isDisabled: false,
      countDown1: 60,
      timer1: null,
      isDisabled1: false,
      manualCodeVisible: false,
      isResend: false,
      icloudDialogVisible: true,
    };
  },
  mounted() {
    this.$refs.input0.focus();
    this.tab = throttle(this.tab, 100, true);
  },
  watch: {
    countDown(value) {
      if (value <= 0) {
        clearInterval(this.timer);
        this.timer = null;
        this.countDown = 60;
      }
    },
    countDown1(value) {
      if (value <= 0) {
        clearInterval(this.timer1);
        this.timer1 = null;
        this.countDown1 = 60;
      }
    },
  },
  methods: {
    tab(a) {
      console.log(a);
      if (a === 1) {
        this.$refs.input1.focus();
        this.input1 = "";
      }
      if (a === 2) {
        this.$refs.input2.focus();
        this.input2 = "";
      }
      if (a === 3) {
        this.$refs.input3.focus();
        this.input3 = "";
      }
      if (a === 4) {
        this.$refs.input4.focus();
        this.input4 = "";
      }
      if (a === 5) {
        this.$refs.input5.focus();
        this.input5 = "";
      }
    },
    // 加载
    getup() {
      if (!this.isDisabled && this.countDown === 60) {
        this.isDisabled = true;
        this.countDown -= 1;

        this.timer = setInterval(() => {
          this.countDown -= 1;
        }, 1000);

        // const loading = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })
        BinddeviceBindApple({
          ...this.$route.params,
          is_resend: 1,
        })
          .then((adj) => {
            // loading.close()
            this.isDisabled = false;
            if (adj.code === 0) {
              this.$message.error(adj.msg);
              return false;
            }
            if (adj.code === 1003) {
              // 需先去 iCloud.com 登录 → 弹出引导弹窗
              this.icloudDialogVisible = true;
              return false;
            }
            // 重发成功后才标记 isResend，失败则不影响后续提交
            this.isResend = true;
          })
          .catch(() => {
            this.isDisabled = false;
          });
      }
    },
    gook() {
      if (!this.isDisabled1 && this.countDown1 === 60) {
        this.isDisabled1 = true;
        this.countDown1 -= 1;

        this.timer1 = setInterval(() => {
          this.countDown1 -= 1;
        }, 1000);

        let key = {
          equipment_id: localStorage.getItem("systemId"),
          code:
            this.input0 +
            this.input1 +
            this.input2 +
            this.input3 +
            this.input4 +
            this.input5,
        };
        if (this.isResend) {
          key.is_resend = 1;
        }
        console.log(key, "key1123");
        appleVerficationCodeNew(key)
          .then((adj) => {
            this.isDisabled1 = false;
            if (adj.code === -1) {
              this.$message.error(this.$t("verification.msg"));
              setTimeout(() => {
                this.$router.push({ name: "Guidance" });
              }, 3000);
            } else if (adj.code === 11 || adj.code === 10) {
              let code =
                this.input0 +
                this.input1 +
                this.input2 +
                this.input3 +
                this.input4 +
                this.input5;
              this.$router.push({
                name: "SelectTheDevice",
                params: { code: code },
              });
              // 成功，已经备份
            }
            //  else if (adj.code === 10) {
            //   // 失败,无备份
            //   this.isshow = true;
            // }
            else {
              // 错误
              this.isshow1 = true;
              this.input0 = null;
              this.input1 = null;
              this.input2 = null;
              this.input3 = null;
              this.input4 = null;
              this.input5 = null;
              this.$refs.input0.focus();
            }
            console.log(adj.code, "adj.code");
            // if (adj.code === 1) {
            //   this.isshow = true
            // } else if (adj.code === 2) {
            //   this.isshow1 = true
            // } else {
            //   this.input0 = null
            //   this.input1 = null
            //   this.input2 = null
            //   this.input3 = null
            //   this.input4 = null
            //   this.input5 = null
            //   this.$refs.input0.focus()
            // }
          })
          .catch(() => {
            this.isDisabled1 = false;
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  position: absolute;
  height: 100%;
  background: #fff;
  overflow: hidden;
}

.Take {
  font-size: 14px;
  color: grey;
  line-height: 20px;
  margin-left: 5%;
  width: 85%;
  max-width: 800px;
}

.Take span {
  color: #0080ff;
  cursor: pointer;
}

.manual-code-tip {
  margin-top: 8px;
}

.Take.code {
  color: #ff0000;
  margin-top: 30px;
}

#Verification {
  margin: 40px 0 40px 5%;
  overflow: hidden;
}

#Verification input {
  float: left;
  background: #f6f8fa;
  border: 2px solid #d5d7db;
  width: 60px;
  height: 80px;
  border-radius: 10.67px;
  font-size: 32px !important;
  color: #000927;
  text-align: center !important;
  font-weight: 700 !important;
  font-family: Noto Sans !important;
  margin-right: 20px;
}

#Verification input:focus {
  border: 2px solid #00eec3;
}

.Popups {
  width: 360px;
  height: 630px;
  margin: -310px -230px;
  padding: 0 50px;
  font-size: 14px;
}

.Popups_title {
  font-size: 16px;
  margin-top: 30px;
  margin-bottom: 20px;
}

.Popups_con {
  font-size: 14px;
  color: grey;
}

.lORr {
  overflow: hidden;
  position: relative;
  margin: 0 0 20px;
}

.lORr div {
  font-size: 13px;
  color: grey;
  height: 20px;
  line-height: 20px;
}

.lORr div:first-child {
  float: left;
  margin-left: 50px;
  cursor: pointer;
}

.lORr div:first-child+div {
  position: absolute;
  width: 50px;
  text-align: center;
  left: 50%;
  margin-left: -25px;
}

.lORr div:first-child+div+div {
  float: right;
  margin-right: 50px;
  cursor: pointer;
}

.lORr div img {
  width: 16px;
  height: 16px;
  float: left;
  margin: 2px;
}

.lORr div:first-child+div+div img {
  float: right;
}

.Verification_ul {
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 420px;
  margin-top: 20px;
}

.Verification_ul .Verification_li {
  position: absolute;
  left: 0;
  -webkit-transition: all 0.8s;
  transition: all 0.8s;
}

.Verification_ul .Verification_li.left {
  left: -106%;
}

.Verification_ul .Verification_li.right {
  left: 106%;
}

.Verification_li_title {
  font-size: 13px;
  color: #45484d;
}

.Verification_li_img {
  width: 350px;
  height: 360px;
  margin-left: 5px;
  margin-top: 20px;
  -webkit-box-shadow: 0 2px 6px -2px rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 6px -2px rgba(0, 0, 0, 0.5);
  border-radius: 22px;
  overflow: hidden;
}

.Verification_li_img img {
  width: 100%;
}

.loginButton {
  width: 270px;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}

.disabled {
  background-color: #d5d7db !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Verification.vue